export default __webpack_public_path__ + "static/media/vinyl_brown.76fa17c8.svg";